export const PROTOCOL_TUS_V1 = 'tus-v1';
export const PROTOCOL_IETF_DRAFT_03 = 'ietf-draft-03';
export const PROTOCOL_IETF_DRAFT_05 = 'ietf-draft-05';
//# sourceMappingURL=options.js.map